var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseX = function SvgCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.02 11.557 22.167 1.411c.4-.4.963-.489 1.256-.196.292.293.204.855-.197 1.256L13.08 12.617l10.51 10.51c.405.404.495.97.203 1.263-.293.293-.859.202-1.264-.203l-10.51-10.51L1.476 24.22c-.4.401-.963.49-1.256.197-.292-.293-.204-.855.197-1.256l10.543-10.542-10.3-10.3c-.404-.405-.495-.97-.202-1.263s.858-.202 1.263.202z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseX;